import { ScrollTrigger } from "@gsap";

/**
 * Layout: FAQ Archief
 * Slug: faq_archive
 */

document.addEventListener('DOMContentLoaded', function() {
	const layouts = document.querySelectorAll('.flex-layout.faq_archive-layout');

	layouts.forEach((layout) => {
		const sections = layout.querySelectorAll('.faq_archive-category');
		const quicklinks = new Map(
			[...layout.querySelectorAll('.faq_grid-quicklink')].map((quicklink) => [
				quicklink.hash.slice(1),
				quicklink,
			]),
		);

		sections.forEach((section) => {
			const quicklink = quicklinks.get(section.id);

			if (!quicklink) return;

			ScrollTrigger.create({
				trigger: section,
				start: 'top center-=25%',
				end: 'bottom center-=25%',
				markers: false,
				onToggle: (self) => {
					quicklink.classList.toggle('active', self.isActive);
				},
			});
		});
	});
});
